/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Page sans titre',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Créer une page et l'insérer sous forme de lien",
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Créer une page Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Ouvrir dans Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Votre page a été créée',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Page créée',
  'editorExtensionLinkCreate.confluencePage.title': 'Créer une page',
  'editorExtensionLinkCreate.genericError.description': 'Actualisez la page et réessayez.',
  'editorExtensionLinkCreate.genericError.title': 'Une erreur est survenue',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    "Créer un ticket en ligne et l'insérer sous forme de lien",
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    "Créer un ticket en ligne et l'insérer sous forme de lien",
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Créer un ticket Jira',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Créer un ticket Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Ouvrir dans Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Votre ticket a été créé',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4': 'Votre ticket a été créé',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Ticket créé',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Ticket créé',
  'editorExtensionLinkCreate.jiraIssue.title': 'Créer un ticket',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Créer un ticket',
  'editorExtensionLinkCreate.keyword.create': 'créer',
  'editorExtensionLinkCreate.keyword.issue': 'ticket',
  'editorExtensionLinkCreate.keyword.new': 'nouveau',
  'editorExtensionLinkCreate.keyword.page': 'page',
  'editorExtensionLinkCreate.keyword.publish': 'publier',
  'editorExtensionLinkCreate.keyword.raise': 'créer',
  'editorExtensionLinkCreate.keyword.space': 'espace',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
